import React from 'react';

const DashCard = ({
    counterCard = false,
    className = '',
    width = 94,
    height = 80,
    style = {},
    children,
    ...rest
}) => {
    const formatSize = size => typeof size === 'number' ? `${size}px` : size;
    const classes = ['dash-card', counterCard && 'counter-card', className]
        .filter(Boolean)
        .join(' ');

    return (
        <section
            className={classes}
            style={{
                '--dash-card-width': formatSize(width),
                '--dash-card-height': formatSize(height),
                ...style,
            }}
            {...rest}
        >
            {children}
        </section>
    );
};

export default DashCard;
